// TelcoTrack — Úřady. Each path uses the matching editor chip (Příprava, Inženýring, Email, Datovka).

import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { permissionAllows, type AppPermissionSectionId } from '@core/shared-bridge';
import { AuthService } from '../services/auth.service';

function sectionForUradyPath(path: string): AppPermissionSectionId | 'any' {
  if (path.startsWith('/urady/priprava')) return 'priprava';
  if (path.startsWith('/urady/inzenyring')) return 'inzenyring';
  if (
    path.startsWith('/urady/komunikace/datovka')
    || path.startsWith('/urady/komunikace/k-schvaleni')
    || path.startsWith('/urady/datovka')
  ) {
    return 'datovka';
  }
  if (
    path.startsWith('/urady/komunikace/email')
    || path.startsWith('/urady/komunikace/posta')
    || path.startsWith('/urady/email')
  ) {
    return 'email';
  }
  return 'any';
}

export const uradyGuard: CanActivateFn = (_route, state) => {
  const authService = inject(AuthService);
  const router = inject(Router);
  const profile = authService.getCurrentUser()?.permissionProfile;
  const path = (state.url.split(/[?#]/)[0] ?? '');
  const section = sectionForUradyPath(path);
  const allowed = section === 'any'
    ? (
      permissionAllows(profile, 'priprava', 'view')
      || permissionAllows(profile, 'inzenyring', 'view')
      || permissionAllows(profile, 'email', 'view')
      || permissionAllows(profile, 'datovka', 'view')
    )
    : permissionAllows(profile, section, 'view');
  if (allowed) return true;
  return router.createUrlTree(['/403']);
};
